<template>
  <div class="home">
    <div class="row">
      <section class="banner d-flex justify-content-center">
        <div class="banner-buttons">
          <router-link to="/vagas?collection=academia"></router-link>
          <router-link to="/vagas?collection=escritorio"></router-link>
        </div>

        <img src="@/assets/images/banner-home.png" aria-hidden="true" v-if="!isMobile" />
        <img src="@/assets/images/banner-home-mobile.png" aria-hidden="true" v-if="isMobile" />
      </section>
    </div>

    <div class="row">
      <div class="col-11 mx-auto d-flex justify-content-center">

        <form action="/vagas" method="get" class="search-box">
          <input type="search" name="term" class="form-control" placeholder="Pesquise por vagas ou palavras-chave" />
          <button type="submit" class="btn btn-primary rounded-pill d-flex align-items-center"><magnify-icon class="h4 mr-1 mb-0" /> Buscar vagas</button>
        </form>

      </div>
    </div>

    <div id="sobre"></div>

    <div class="row py-5" id="mapa">
      <div class="col-12 col-md-10 mx-auto">
        <img src="@/assets/images/img-mapa.png" aria-hidden="true" width="100%" class="my-5" v-if="!isMobile" />
        <img src="@/assets/images/img-mapa-mobile.png" aria-hidden="true" width="100%" class="my-5" v-if="isMobile" />
      </div>
    </div>

    <div class="row" id="video">
      <section class="w-100 d-flex justify-content-center">
        <div class="iframe-container">
          <iframe src="https://www.youtube.com/embed/vKkvNTuUP2w" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        </div>

        <!-- <img src="@/assets/images/bg-video.png" aria-hidden="true" width="100%" /> -->
      </section>
    </div>

    <!-- <div class="row my-5 py-5" id="mais-de">
      <div class="col-11 col-md-9 mx-auto">
        <div class="row align-items-center">
          <div class="col-6">
            <h1><span>MAIS DE 130</span><br /><span>ACADEMIAS</span> EM<br />TODO O BRASIL!</h1>
            <p>Todos os dias escolhemos transformar e<br />impactar milhares de vida.</p>
          </div>
          <div class="col-6">
            <img src="@/assets/images/foto1home.jpg" aria-hidden="true" />
          </div>
        </div>
      </div>
    </div> -->

    <!-- <div class="row my-5" id="search-bar">
      <div class="col-11 col-md-9 mx-auto">
        <div class="row align-items-center">
          <div class="col-12 col-md-6">
            <img src="@/assets/images/vemprotreino.png" aria-hidden="true" />
          </div>
          <div class="col-12 col-md-6 d-flex align-items-center py-3">
            <input type="search" class="form-control border-0" placeholder="Pesquise por vagas ou palavras-chave" />
            <button type="button" class="btn btn-color-2 flex-shrink-0 ml-3 d-flex align-items-center"><magnify-icon class="h4 mr-1 mb-0" /> Buscar vagas</button>
          </div>
        </div>
      </div>
    </div> -->


    <div class="row" id="galeria">
      <div class="col-11 col-md-9 mx-auto">
        <div class="row align-items-center">
          <div class="col-12 col-md-6 order-2 order-md-1">
            <!-- <div class="gallery">
              <img src="@/assets/images/gallery-1.jpg" aria-hidden="true" v-show="galleryItem==1" />
              <img src="@/assets/images/gallery-2.jpg" aria-hidden="true" v-show="galleryItem==2"/>
              <img src="@/assets/images/gallery-3.jpg" aria-hidden="true" v-show="galleryItem==3"/>
              <img src="@/assets/images/gallery-4.jpg" aria-hidden="true" v-show="galleryItem==4"/>
              <div class="gallery-thumbs">
                <img src="@/assets/images/gallery-1.jpg" aria-hidden="true" @click="galleryItem = 1" :class="{'active': galleryItem==1}" />
                <img src="@/assets/images/gallery-2.jpg" aria-hidden="true" @click="galleryItem = 2" :class="{'active': galleryItem==2}" />
                <img src="@/assets/images/gallery-3.jpg" aria-hidden="true" @click="galleryItem = 3" :class="{'active': galleryItem==3}" />
                <img src="@/assets/images/gallery-4.jpg" aria-hidden="true" @click="galleryItem = 4" :class="{'active': galleryItem==4}" />
              </div>
            </div> -->
            <Slider :autoplay="true">
              <img src="@/assets/images/gallery-1.png" aria-hidden="true" />
              <img src="@/assets/images/gallery-2.png" aria-hidden="true" />
              <img src="@/assets/images/gallery-3.png" aria-hidden="true" />
              <img src="@/assets/images/gallery-4.png" aria-hidden="true" />
            </Slider>

            <p v-if="isMobile" class="text-white">
              Cuidar da saúde deve ser prazeroso, acessível e para todos. Estamos revolucionando o mercado fitness, oferecendo um serviço premium com um preço justo, para que cada vez mais pessoas possam dar o play no seu modo Blue e viver uma vida mais saudável e feliz.
            </p>
          </div>
          <div class="col-12 col-md-6 order-1 order-md-2 px-0 px-md-5">
            <img src="@/assets/images/texto-galeria.png" aria-hidden="true" width="100%" class="mb-5 mb-md-0" v-if="!isMobile" />
            <img src="@/assets/images/texto-galeria-mobile.png" aria-hidden="true" width="100%" class="mb-5 mb-md-0" v-if="isMobile" />
          </div>
        </div>
      </div>
    </div>

    <div class="row" id="diferencial">
      <div class="col-12 col-md-10 mx-auto d-flex justify-content-center">
        <img src="@/assets/images/diferencial-title.png" aria-hidden="true" v-if="!isMobile" />
        <img src="@/assets/images/diferencial-title-mobile.png" aria-hidden="true" v-if="isMobile" />
      </div>

      <div class="col-10 col-md-10 mx-auto">
        <Slider :autoplay="true">
          <img src="@/assets/images/slider-1.png" aria-hidden="true" v-if="!isMobile" />
          <img src="@/assets/images/slider-1-mobile.png" aria-hidden="true" v-if="isMobile" />
          <img src="@/assets/images/slider-2.png" aria-hidden="true" v-if="!isMobile" />
          <img src="@/assets/images/slider-2-mobile.png" aria-hidden="true" v-if="isMobile" />
          <img src="@/assets/images/slider-3.png" aria-hidden="true" v-if="!isMobile" />
          <img src="@/assets/images/slider-3-mobile.png" aria-hidden="true" v-if="isMobile" />
          <img src="@/assets/images/slider-4.png" aria-hidden="true" v-if="!isMobile" />
          <img src="@/assets/images/slider-4-mobile.png" aria-hidden="true" v-if="isMobile" />
          <img src="@/assets/images/slider-5.png" aria-hidden="true" v-if="!isMobile" />
          <img src="@/assets/images/slider-5-mobile.png" aria-hidden="true" v-if="isMobile" />
          <img src="@/assets/images/slider-6.png" aria-hidden="true" v-if="!isMobile" />
          <img src="@/assets/images/slider-6-mobile.png" aria-hidden="true" v-if="isMobile" />
        </Slider>
      </div>
    </div>
    

    <div class="row mt-5 py-5" id="beneficios">
      <div class="col-12 col-md-10 mx-auto d-flex justify-content-center">
        <img src="@/assets/images/benefits-title.png" aria-hidden="true" v-if="!isMobile"  />
        <img src="@/assets/images/benefits-title-mobile.png" aria-hidden="true" v-if="isMobile"  />
      </div>

      <div class="col-11 col-md-10 mx-auto py-5">
        <Benefits />
      </div>
    </div>


    <div class="row py-5" id="depoimentos">
      <div class="col-12">
        <Slider :autoplay="true">


          <img src="@/assets/images/img-depoimento-2.png" aria-hidden="true" width="100%" v-if="!isMobile" />
          <img src="@/assets/images/img-depoimento-2-mobile.png" aria-hidden="true" width="100%" v-if="isMobile" />

          <img src="@/assets/images/img-depoimento-3.png" aria-hidden="true" width="100%" v-if="!isMobile" />
          <img src="@/assets/images/img-depoimento-3-mobile.png" aria-hidden="true" width="100%" v-if="isMobile" />
        </Slider>
      </div>
    </div>


    <div class="row py-5" id="areas">
      <div class="col-12 d-flex justify-content-center mb-4">
        <img src="@/assets/images/img-title-areas.png" aria-hidden="true" />
      </div>

      <div class="col-11 col-md-9 mx-auto py-5">
        <div class="areas-boxes">
          <router-link to="/vagas?collection=escritorio">
            <img src="@/assets/images/area-escritorio.png" />
          </router-link>
          <router-link to="/vagas?collection=academia">
            <img src="@/assets/images/area-academia.png" />
          </router-link>
          <router-link to="/vagas?collection=estagio">
            <img src="@/assets/images/area-estagio.png" />
          </router-link>
        </div>
      </div>
    </div>

    
    <div class="row" id="faq">
      <div class="col-10 col-md-6 mx-auto">
        <h1 class="text-white">FAQ</h1>
        <Faq />
      </div>
    </div>
  </div>
</template>

<script>
import Slider from "@/components/Slider.vue";
import Faq from "@/components/Faq.vue";
import Share from "@/components/jobs/Share.vue";
import MagnifyIcon from "vue-material-design-icons/Magnify.vue";
import Benefits from "../components/Benefits.vue";
import { computed } from "vue";

export default {
  name: "home",

  data() {
    return {
      galleryItem: 1,
    };
  },

  components: {
    Slider,
    Faq,
    Share,
    MagnifyIcon,
    Benefits
  },

  computed: {
    isMobile: function(){
      return window.innerWidth < 720;
    },
  },

  mounted() {},

  methods: {
  },
};
</script>

<style lang="scss" scoped>
  .banner {
    position: relative;
    width: 100%;

    .banner-buttons{
      a:first-of-type{
        width: 13vw;
        height: 3vw;
        display: block;
        position: absolute;
        left: 19vw;
        bottom: 10vw;

        @media (max-width: 720px){
          width: 40vw;
          height: 10vw;
          left: 10vw;
        }
      }
      a:last-of-type{
        width: 13vw;
        height: 3vw;
        display: block;
        position: absolute;
        left: 36vw;
        bottom: 10vw;

        @media (max-width: 720px){
          width: 40vw;
          height: 10vw;
          left: 55vw;
        }
      }
    }

    img{
      width: 100%;
    }
  }

  .home{
    margin: 0 -15px;
    background-image: url("../assets/images/bg-site.png");
    background-size: 100vw;
  }

  .search-box{
    width: 500px;
    max-width: 90%;
    box-shadow: 0px 4px 40px 0px #0000000D;
    border-radius: 30px;
    display: flex;
    align-items: center;
    padding: 0 10px;
    background-color: #fff;
    position: fixed;
    bottom: 30px;
    z-index: 10;

    .form-control{
      min-height: 52px;
      flex-grow: 1;
      margin: 0;
      border: none;
      border-radius: inherit;
    }
    .btn{
      flex-shrink: 0;
    }
  }

  #mais-de{
    h1{
      font-weight: 900;
      line-height: 1.1;
      text-align: left;
      font-size: 48px;
      color: #0023F3;
      font-weight: 900;
      span{
        background: #DBFF07;
        padding: 0 10px;
      }
    }

    p{
      font-size: 18px;
      font-style: italic;
      font-weight: 400;
      line-height: 1.5;
      text-align: left;
      margin: 20px 0 0 0;
    }
  }

  #video{
    position: relative;
    
    .iframe-container {
      margin-top: 80px;
      position: relative;
      overflow: hidden;
      width: 800px;
      max-width: 80%;
      height: 500px;

      /* Then style the iframe to fit in the container div with full height and width */
      iframe {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        width: 100%;
        height: 100%;
        border-radius: 20px;
      }
    }

  }

  #search-bar{
    background-image: url("../assets/images/search-bar.jpg");
    padding: 15px 0;
  }

  #galeria{
    // background-image: url("../assets/images/bg-galeria.png");
    background-repeat: no-repeat;
    background-size: cover;
    padding-top: 250px;
    padding-bottom: 250px;

    h1{
      font-family: 'gothamcond_book_italic';
      font-weight: 100 !important;
      line-height: 1.1;
      text-align: left;
      font-size: 42px;
      color: #262626;
      font-style: italic;
      text-transform: uppercase;
      span{
        font-family: 'Gotham HTF';
        font-weight: bold;
        color: #0023F3;
        font-size: 90%;
      }
    }

    p{
      font-size: 18px;
      font-style: italic;
      font-weight: 400;
      line-height: 1.5;
      text-align: left;
      margin: 20px 0 0 0;
    }
  }

  .gallery{
    display: flex;
    width: 100%;
    gap: 20px;

    @media (max-width: 600px){
      flex-direction: column;
    }

    img{
      width: calc(100% - 100px);
      height: 100%;
      flex: 1;
      object-fit: cover;
      border-radius: 22px;
      @media (max-width: 600px){
        width: 100%;
      }
    }

    .gallery-thumbs{
      width: 100px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 10px;

      @media (max-width: 600px){
        width: 100%;
        flex-direction: row;
        overflow: auto;
        justify-content: start;
      }

      img{
        width: 100px;
        height: 100px;
        flex-shrink: 0;
        object-fit: cover;
        border-radius: 12px;
        filter: grayscale(0.8);
        transition: filter 0.1s linear;
        cursor: pointer;
        &:hover, &.active{
          filter: grayscale(0);
        }
      }
    }
  }

  /deep/ .carousel-container{
    margin-top: 50px;
    padding-bottom: 100px;

    [data-action="stop"]{
      display: none;
    }

    .tns-nav{
      width: 100%;
      position: absolute;
      bottom: -40px;
      display: flex;
      justify-content: center;
      gap: 10px;

      button{
        width: 15px;
        height: 15px;
        background-color: #EAEAEA;
        border-radius: 50%;
        border: none;

        &.tns-nav-active{
          background: #050D9A;
        }
      }
    }
  }

  #areas{
    h1{
      display: inline-block;
      padding: 0 0 50px 0;
      align-self: center;
      font-family: 'gothamcond_book_italic';
      font-weight: 100 !important;
      line-height: 1.1;
      text-align: center;
      font-size: 42px;
      color: #000;
      font-style: italic;
      span{
        font-family: 'Gotham HTF';
        font-style: normal;
        font-weight: bold;
        display: block;
        color: #0023F3;
        text-transform: uppercase;
        font-size: 110%;
      }
    }

    .areas-boxes{
      display: flex;
      flex-wrap: wrap;
      gap: 30px;
      justify-content: center;

      a{
        max-width: 300px;
        transition: transform 0.2s ease-in-out;

        &:hover{
          transform: translateY(-10px);
        }
      }
    }
  }



  #faq{
    padding: 130px 0;

    h1{
      
      font-size: 48px;
      font-weight: 700;
      line-height: 68px;
      letter-spacing: 0em;
      text-align: left;
      color: #000000;
      margin-bottom: 40px;

      @media (max-width: 600px){
        font-size: 38px;
        line-height: 1.3;
      }
    }

    /deep/li{
      list-style: disc;
      font-size: 20px;
      font-weight: 400;
      line-height: 36px;
      background: #0078FF;
      border-color: transparent;
      border-radius: 15px;

      button{
        color: #fff;
        font-size: 18px;

        .icon::before{
          font-size: 22px;
          font-weight: normal;
          font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
        }
      }

      p{
        font-size: 16px;
        line-height: 1.5;
        color: #FFFFFF;
      }
    }
  }
</style>
